import {Routes} from "@angular/router";
import {DealsComponent} from "./deals.component";

export const dealsRoutes: Routes = [
  {path: '', component: DealsComponent}
];
